import styled from "styled-components";
import { UIColor, UIFont } from "../types";
import { FontFamily, FontWeight } from "../types/fonts";

export const Text = styled.p<{
  font?: UIFont;
  textColor?: UIColor;
}>`
  &&& {
    font-family: ${({ font: { family = FontFamily.HarmoniaSansStd } = {} }) =>
      family};
    font-weight: ${({ font: { weight = FontWeight.Normal } = {} }) => weight};
    color: ${({ theme, textColor: { hex = theme.colors.black } = {} }) => hex};
  }
`;
